import { render, staticRenderFns } from "./TenantList.vue?vue&type=template&id=f48c4cf6&scoped=true&lang=pug&"
import script from "./TenantList.vue?vue&type=script&lang=js&"
export * from "./TenantList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48c4cf6",
  null
  
)

export default component.exports